export default __webpack_public_path__ + "static/cake-9e854fc0e5b0cec88419824e15824de9.jpg";